module.exports = __webpack_public_path__ + "static/img/azb3.74020c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/gwphoto/azb3.jpg
// module id = 8Vts
// module chunks = 1